module.exports = __webpack_public_path__ + "static/media/auto_farm.09ae772a.svg";